export const controlPanelWidth = '360px';

export const controlPanelId = 'controlPanelContainer';

export const mainContainerId = 'mainContainer';

export const notDraggableClass = 'notDraggable';

export const phoneFieldDataAttrFocus = 'phoneField';

export const roundIconBgTypes = {
  call: 'call',
  drop: 'drop',
  missed: 'missed',
  disconnected: 'disconnected',
  transparent: 'transparent',
  hasActiveCalls: 'hasActiveCalls',
};

export const mediaErrors = {
  AbortError:
    'В браузере возникла проблема, которая не позволяет использовать микрофон',
  NotAllowedError:
    'Приложению Dispex отказано в использовании микрофона. Если вы хотите пользоваться телефонией, разрешите приложению использовать микрофон в настройках браузера',
  NotFoundError: 'Микрофон не найден',
  NotReadableError: 'Возникла ошибка, которая препятствует доступу к микрофону',
  UnknownError: 'При попытке подключить микрофон возникла неизвестная ошибка',
};

export const defaultSelectedRingtoneDevice = { deviceId: 'default' };

export const dispatcherDispexValue = 'Own';
